<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

// Custom Components
import superService from "@/helpers/APIService/super.service";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { time_zones } from "@/helpers/global.variable";

export default {
  data() {
    return {
      pbx_form: {
        select_domain: "",
        sub_domain: "",
        pbx: "",
        ip: "",
        domain_timezone: "",
        extension_limit: "",
        domain_enabled: true,
        domain_uuid: "",
        domain_ip: "",
        domain_name: "",
        stripe_customer_id: "",
        domain_description: "",
        is_active: true,
        domain_subscription: true,
        audiomsg: false,
        audiofile: "",
        push_notification: false,
        dailyvmaildel: false,
        // roomblock: false,
        main_cid: "",
        emr_cid: "",
        vpn_ip: "",
        vm_admin_pin: "",
      },
      tab_domain: "new-domain",
      main_domain: { text: "cloudext.co", value: "cloudext.co" },
      ip_whitelisted: "--",
      submitted: false,
      isBtnLoading: false,
      domainLoading: true,
      isError: false,
      errorMessage: null,
      select_domain_options: [],
      select_domain_options_copy: [],
      pbx_options: [],
      timeZoneOptions: time_zones,
    };
  },
  components: {
    Multiselect,
  },
  props: {
    pbxForm: Object,
    hotelId: String,
    isEdit: Boolean,
  },
  emits: ["submitted", "cancelSubmit"],
  validations: {
    pbx_form: {
      select_domain: { required },
      pbx: { required },
      domain_uuid: {
        required: requiredIf(function () {
          if (this.tab_domain !== "new-domain") {
            return true;
          }
        }),
      },
      domain_timezone: { required },
      // domain_ip: { required },
      // domain_name: { required },
      extension_limit: { required },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to get Domain list
    async setValue() {
      try {
        const response = await PbxService.getDomainList();
        if (response) {
          response.forEach((element) => {
            this.select_domain_options_copy.push({
              value: element.domain_uuid,
              text: element.domain_name,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
      // Method is used to get Pbx Server List
      try {
        const pbxresponse = await PbxService.getPBXServerList();
        pbxresponse.result.forEach((element) => {
          this.pbx_options.push({
            value: element.server_ip,
            text: element.server_name,
            item: element,
          });
        });
        this.domainLoading = false;
        if (this.isEdit && this.pbxForm !== null) {
          this.select_domain_options = this.select_domain_options_copy;
          this.tab_domain = "existing-domain";
          this.update_domain(this.pbxForm.domain_uuid);
        } else {
          this.pbx_form.select_domain = this.main_domain;
          this.select_domain_options = [
            { text: "cloudext.co", value: "cloudext.co" },
          ];
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // On domain select
    onChange(event) {
      if (event == "new-domain") {
        Object.keys(this.pbx_form).map((key) => {
          if (this.pbx_form[key] !== null && this.pbx_form[key] !== undefined) {
            this.pbx_form[key] = "";
          }
        });
        this.select_domain_options = [
          { text: "cloudext.co", value: "cloudext.co" },
        ];
        this.pbx_form.select_domain = this.main_domain;
      } else {
        this.select_domain_options = this.select_domain_options_copy;
      }
    },
    // Select Domain And Update input filed
    update_domain(domain_uuid) {
      if (domain_uuid == undefined) return;
      this.domainLoading = true;
      let domainId =
        typeof domain_uuid == "string" ? domain_uuid : domain_uuid.value;
      PbxService.getDomainDetailList(domainId)
        .then((res) => {
          this.domainLoading = false;
          this.pbx_form = res;
          this.pbx_form.domain_ip = res.ip;
          this.pbx_form.pbx = { text: res.pbx, value: res.ip };
          this.pbx_form.extension_limit = res.extension_limit;
          this.pbx_form.select_domain = {
            value: res.domain_uuid,
            text: res.domain_name,
          };
        })
        .catch((error) => {
          this.domainLoading = false;
          errorHandler(error);
        });
    },
    // Select PBX Server And Update input filed
    update_server() {
      let pbxobj = this.pbx_form.pbx;
      this.pbx_options.forEach((element) => {
        if (pbxobj.value == element.value) {
          this.pbx_form.ip = element.item.server_ip;
        }
      });
      if (this.isEdit == false && this.tab_domain == "new-domain") {
        this.pbx_form.domain_name =
          this.pbx_form.sub_domain + "." + this.pbx_form.select_domain.value;
      }
    },
    // Method is used to handle submit form
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.tab_domain == "new-domain") {
          const domain_name =
            this.pbx_form.sub_domain + "." + this.pbx_form.select_domain.value;
          const data = {
            domain_name: domain_name,
            domain_enabled: this.pbx_form.domain_enabled,
            domain_description: this.pbx_form.domain_description,
            pbx: this.pbx_form.pbx.text,
            ip: this.pbx_form.ip,
            domain_timezone: this.pbx_form.domain_timezone,
            stripe_customer_id: this.pbx_form.stripe_customer_id,
            domain_subscription:
              this.pbx_form.domain_subscription == true ? "active" : "",
            main_cid: this.pbx_form.main_cid,
            emr_cid: this.pbx_form.emr_cid,
            vpn_ip: this.pbx_form.vpn_ip,
            audiomsg: this.pbx_form.audiomsg,
            audiofile: this.pbx_form.audiofile,
            dailyvmaildel: this.pbx_form.dailyvmaildel,
            staffauth: "",
            // roomblock: this.pbx_form.roomblock,
            vm_admin_pin: this.pbx_form.vm_admin_pin,
            extension_limit: this.pbx_form.extension_limit,
          };
          PbxService.addDomainDetail(data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              superService.updateHotel(this.hotelId, {
                pbx_domain_name: response.result.domain_name,
                pbx_domain_uuid: response.result.domain_uuid,
              });
              Middleware.notification(
                "Domain successfully updated !!",
                "success"
              );
              this.$emit("submitted", "submitted");
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          let pbx_domain_uuid =
            typeof this.pbx_form.select_domain == "string"
              ? this.pbx_form.select_domain
              : this.pbx_form.select_domain.value;
          superService
            .updateHotel(this.hotelId, {
              pbx_domain_name: this.pbx_form.domain_name,
              pbx_domain_uuid: pbx_domain_uuid,
            })
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              this.$emit("submitted", "submitted");
              Middleware.notification(
                "Domain successfully Updated !!",
                "success"
              );
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>PBX connection</h4>
        <hr />
      </div>
      <b-form @submit.prevent="onSubmit">
        <div class="row">
          <!-- Domain Details -->
          <h4 class="card-title">
            Domain Details
            <b-spinner
              v-if="domainLoading"
              class="ms-2"
              small
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </h4>
          <hr />
          <div class="col-md-12">
            <b-form-group class="mb-3" label-for="pbx_serve">
              <span slot="label">
                Create Customer With <span class="text-danger">*</span>
              </span>
              <div class="row">
                <div class="col-md-2">
                  <b-form-radio
                    v-model="tab_domain"
                    name="new_domain"
                    value="new-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> New Domain </span>
                  </b-form-radio>
                </div>
                <div class="col-3">
                  <b-form-radio
                    v-model="tab_domain"
                    name="existing_domain"
                    value="existing-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> Existing Domain </span>
                  </b-form-radio>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-domain">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Select </span> Domain
                <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.select_domain"
                :options="select_domain_options"
                @input="update_domain"
                :show-labels="false"
                placeholder="Search Domain"
                label="text"
                track-by="value"
                id="select-domain"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.select_domain.$error,
                }"
              ></multiselect>
              <div
                v-if="submitted && $v.pbx_form.select_domain.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.select_domain.required"
                  >Select Domain is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4" v-if="tab_domain == 'new-domain'">
            <b-form-group class="mb-3" label-for="sub_domain">
              <span slot="label">
                Sub Domain Name <span class="text-danger">*</span></span
              >
              <div class="row mx-1 align-items-end">
                <b-form-input
                  id="sub_domain"
                  type="text"
                  autocomplete="off"
                  v-model="pbx_form.sub_domain"
                  class="col-auto"
                ></b-form-input>
                <span class="col-auto text-dark"
                  >.{{ pbx_form.select_domain ? "cloudext.co" : "" }}</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-server">
              <span slot="label">
                Select Server <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.pbx"
                :options="pbx_options"
                @input="update_server"
                :show-labels="false"
                placeholder="Search Server"
                label="text"
                track-by="value"
                id="select-server"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.pbx.$error,
                }"
              ></multiselect>

              <div
                v-if="submitted && $v.pbx_form.pbx.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.pbx.required"
                  >Select Server is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Server </span> Ip
                <span class="text-danger">*</span></span
              >
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.ip"
                readonly
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-zone-input"
            >
              <span slot="label"> Timezone </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                :options="timeZoneOptions"
                v-model="pbx_form.domain_timezone"
                type="text"
                autocomplete="off"
              ></b-form-select>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_timezone.required"
                  >Time Zone is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="extension_limit">
              <span slot="label">
                Extension Limit <span class="text-danger">*</span></span
              >
              <b-form-input
                id="extension_limit"
                type="number"
                autocomplete="off"
                v-model="pbx_form.extension_limit"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.extension_limit.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.extension_limit.required"
                  >Extension Limit is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <!-- <div class="col-md-2">
            <div class="mb-3">
              <label for="domain_enabled">Domain Enabled</label>
              <div class="form-check form-switch my-1" slot="domain_enabled">
                <input
                  class="form-check-input"
                  id="domain_enabled"
                  type="checkbox"
                  v-model="pbx_form.domain_enabled"
                />
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-8">
            <div class="mb-3">
              <label for="ip_whitelisted">IP Whitelisted in Firewall:</label>
              <h6>{{ ip_whitelisted }}</h6>
            </div>
          </div> -->

          <!-- Basic Details -->
          <!-- <h4 class="card-title">Basic Details</h4>
          <hr />

          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="domain_name">
              <span slot="label">
                Domain Name <span class="text-danger">*</span></span
              >
              <b-form-input
                id="domain_name"
                type="text"
                autocomplete="off"
                v-model="pbx_form.domain_name"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.domain_name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.domain_name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.domain_name.required"
                  >Domain Name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="domain_uuid">
              <span slot="label">
                Domain UUID
                <span class="text-danger" v-if="tab_domain !== 'new-domain'"
                  >*</span
                ></span
              >
              <b-form-input
                id="domain_uuid"
                type="text"
                autocomplete="off"
                v-model="pbx_form.domain_uuid"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.domain_uuid.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.domain_uuid.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.domain_uuid.required"
                  >Domain is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                Domain Ip <span class="text-danger">*</span></span
              >
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.domain_ip"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.domain_ip.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.pbx_form.domain_ip.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.domain_ip.required"
                  >Domain Ip is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="stripe_customer_id">
              <span slot="label"> Strip Id </span>
              <b-form-input
                id="stripe_customer_id"
                type="text"
                autocomplete="off"
                v-model="pbx_form.stripe_customer_id"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <label for="is_active">Active</label>
              <div class="form-check form-switch my-1" slot="is_active">
                <input
                  class="form-check-input"
                  id="is_active"
                  type="checkbox"
                  v-model="pbx_form.is_active"
                />
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <label
                for="domain_subscription"
                v-b-popover.hover.top="'Domain Subscription'"
                >Domain Subscription</label
              >
              <div
                class="form-check form-switch my-1"
                slot="domain_subscription"
              >
                <input
                  class="form-check-input"
                  id="domain_subscription"
                  type="checkbox"
                  v-model="pbx_form.domain_subscription"
                />
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <b-form-group class="mb-3" label-for="address-input">
              <span slot="label"> Description </span>
              <b-form-textarea
                id="description"
                v-model="pbx_form.domain_description"
              ></b-form-textarea>
            </b-form-group>
          </div> -->

          <!-- Default Settings -->
          <h4 class="card-title">Default Settings</h4>
          <hr />

          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label"> Outbound Caller ID</span>
              <b-form-input
                id="main_cid"
                type="number"
                v-model="pbx_form.main_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="main_cname">
              <span slot="label"> Outbound Caller Name</span>
              <b-form-input
                id="main_cname"
                type="text"
                autocomplete="off"
                v-model="pbx_form.main_cname"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="emr_cid">
              <span slot="label"> Emergency Caller ID </span>
              <b-form-input
                id="emr_cid"
                type="number"
                v-model="pbx_form.emr_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="emr_cname">
              <span slot="label"> Emergency Caller Name </span>
              <b-form-input
                id="emr_cname"
                type="text"
                autocomplete="off"
                v-model="pbx_form.emr_cname"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vpn_ip">
              <span slot="label"> VPN IP </span>
              <b-form-input
                id="vpn_ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vpn_ip"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vm_admin_pin">
              <span slot="label"> Admin Pin </span>
              <b-form-input
                id="vm_admin_pin"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vm_admin_pin"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label
                for="dailyvmaildel"
                v-b-popover.hover.top="'Daily VoiceMail Delete'"
                >Daily VoiceMail Delete</label
              >
              <div class="form-check form-switch my-1" slot="dailyvmaildel">
                <input
                  class="form-check-input"
                  id="dailyvmaildel"
                  type="checkbox"
                  v-model="pbx_form.dailyvmaildel"
                />
              </div>
            </div>
          </div>

          <!-- Voice Message Advertisement -->
          <!-- <h4 class="card-title">Voice Message Advertisement</h4>
          <hr />

          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="audiofile">
              <span slot="label"> Audio File </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                v-model="pbx_form.audiofile"
                type="text"
                autocomplete="off"
              >
                <b-form-select-option value="npport"
                  >No Port</b-form-select-option
                >
                <b-form-select-option value="nppay"
                  >No Pay</b-form-select-option
                >
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="audiomsg" v-b-popover.hover.top="'Audio Message'"
                >Audio Message</label
              >
              <div class="form-check form-switch my-1" slot="audiomsg">
                <input
                  class="form-check-input"
                  id="audiomsg"
                  type="checkbox"
                  v-model="pbx_form.audiomsg"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label
                for="push_notification"
                v-b-popover.hover.top="'Mobile Push Notification'"
                >Mobile Push Notification</label
              >
              <div class="form-check form-switch my-1" slot="push_notification">
                <input
                  class="form-check-input"
                  id="push_notification"
                  type="checkbox"
                  v-model="pbx_form.push_notification"
                />
              </div>
            </div>
          </div> -->

          <div class="col-md-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>
